<template>
    <div class="dacu-goods">
        <!-- 筛选条件 -->
        <div class="query-section">
            <div class="form-row">
                <div class="form-group">
                    <label>推广分类：</label>
                    <el-select v-model="queryForm.category" @change="onFilterChange" placeholder="全部" clearable>
                        <el-option label="全部" value="" />
                        <el-option v-for="category in promotionCategories" :key="category" :label="category"
                            :value="category" />
                    </el-select>
                </div>
                <div class="form-group">
                    <label>关键内容：</label>
                    <el-input v-model="queryForm.keyword" @input="onKeywordInput" placeholder="请输入品牌、名称等" clearable />
                </div>
                <!-- <div class="form-group">
                    <button @click="loadPromotionContent" :disabled="loading" style="width: 100%;">
                        {{ loading ? '加载中...' : '加载攻略' }}
                    </button>
                </div> -->
            </div>
        </div>

        <!-- 推广内容列表 -->
        <div class="results-section" ref="resultsSection" @scroll="handleScroll">
            <div v-if="loading" class="loading">
                <div class="loading-spinner"></div>
                <p>正在加载...</p>
            </div>

            <div v-else-if="promotionContentList.length === 0" class="empty-state">
                <div class="empty-icon">📝</div>
                <h3>暂无内容</h3>
                <p v-if="queryForm.keyword">未找到包含"{{ queryForm.keyword }}"的内容</p>
                <p v-else>请选择分类或输入关键词查询推广攻略</p>
            </div>

            <div v-else class="content-list">
                <!-- 搜索结果统计 -->
                <div v-if="promotionContentList.length > 0 && currentUser.role === 'ADMIN'" class="search-stats">
                    <div class="stats-info">
                        <span v-if="queryForm.category" class="search-category">分类:{{ queryForm.category }}</span>
                        <span v-if="!queryForm.category" class="search-category">分类: 全部</span>
                        <span v-if="queryForm.keyword" class="search-keyword">内容:"{{ queryForm.keyword }}"</span>
                        <span class="result-count">查到{{ promotionContentList.length }}条</span>
                    </div>
                </div>

                <div v-for="item in promotionContentList" :key="item.id" class="content-card">
                    <!-- <div class="content-header">
                        <div class="content-title">发布时间:{{ formatTime(item.updatedTime) }}</div>
                        <div class="content-category">
                            <span class="category-tag">{{ item.category }}</span>
                        </div>
                    </div> -->

                    <div class="content-body">
                        <div class="content-text" v-if="isRichText(item.content)" v-html="item.content"></div>
                        <div class="content-text" v-else>{{ item.content }}</div>
                    </div>

                    <div class="content-footer">
                        <!-- <div class="content-status">
                            <span class="status-badge" :class="{ 'active': item.isActive, 'inactive': !item.isActive }">
                                {{ item.isActive ? '启用' : '禁用' }}
                            </span>
                        </div> -->
                        <!-- <div class="content-time">
                           发布时间： {{ formatTime(item.updatedTime) }}
                        </div> -->
                        <div class="content-actions">
                            <button style="color: #42b983;border:1px solid #42b983;background-color: #fff;"
                                @click="handleInvalidReport(item)">失效上报</button>
                            <button @click="copyContent(item)" class="action-btn copy-btn">
                                转链后复制分享
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 回到顶部按钮 -->
        <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
            <i class="el-icon-top"></i>
        </div>
    </div>
</template>

<script>
import { getPromotionContentCategories, getPromotionContent, getPromotionContentByCategory, getCurrentUser, reportPromotionContentInvalidBySpuid, batchCreatePromotionLinks } from '@/utils/jdApi'
import { copyRichTextWithMessage } from '@/utils/clipboard'

export default {
    name: 'GuideA',
    data() {
        return {
            loading: false,
            queryForm: {
                category: '',
                keyword: '',
            },
            promotionCategories: [],
            promotionContentList: [],
            allContentList: [], // 缓存所有内容，用于前端过滤
            showBackToTop: false,// 控制回到顶部按钮显示
            currentUser: null,
        }
    },
    mounted() {
        this.currentUser = getCurrentUser()
        this.loadCategories()
        this.loadPromotionContent() // 进入页面直接加载全部内容
    },
    methods: {
        // 加载推广内容分类
        async loadCategories() {
            try {
                const response = await getPromotionContentCategories()
                if (response.success) {
                    this.promotionCategories = response.data || []
                } else {
                    console.error('加载分类失败')
                }
            } catch (error) {
                console.error('加载分类失败')
            }
        },

        // 加载推广内容
        async loadPromotionContent() {
            this.loading = true
            try {
                let response
                if (this.queryForm.category) {
                    // 按分类查询，设置一个较大的size以获取所有数据
                    response = await getPromotionContentByCategory(this.queryForm.category, { page: 0, size: 10000 })
                } else {
                    // 查询所有内容，设置一个较大的size以获取所有数据
                    response = await getPromotionContent({ page: 0, size: 10000 })
                }

                if (response.success) {
                    this.allContentList = response.data || []
                    this.applyFilters()
                } else {
                    this.$message?.error?.('加载失败')
                }
            } catch (error) {
                this.$message?.error?.('加载失败')
            } finally {
                this.loading = false
            }
        },

        // 应用所有过滤条件
        applyFilters() {
            let filteredList = [...this.allContentList]

            // 分类过滤
            if (this.queryForm.category) {
                filteredList = filteredList.filter(item => item.category === this.queryForm.category)
            }

            // 关键词过滤
            if (this.queryForm.keyword) {
                filteredList = this.filterByKeyword(filteredList, this.queryForm.keyword)
            }

            this.promotionContentList = filteredList
        },

        // 关键词输入处理（实时搜索）
        onKeywordInput() {
            // 防抖处理，避免频繁搜索
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.applyFilters()
            }, 300)
        },

        // 前端关键词过滤
        filterByKeyword(contentList, keyword) {
            if (!keyword || !keyword.trim()) {
                return contentList
            }

            const searchKeyword = keyword.toLowerCase().trim()
            return contentList.filter(item => {
                // 在标题中搜索
                const titleMatch = item.title && item.title.toLowerCase().includes(searchKeyword)
                // 在内容中搜索
                const contentMatch = item.content && item.content.toLowerCase().includes(searchKeyword)
                // 在分类中搜索
                const categoryMatch = item.category && item.category.toLowerCase().includes(searchKeyword)

                return titleMatch || contentMatch || categoryMatch
            })
        },

        // 筛选条件变化处理
        onFilterChange() {
            this.applyFilters()
        },

        async copyContent(item) {
            let content = item.content || ''
            const shortLinkPattern = /https?:\/\/u\.jd\.com\/[^\s<&'"]+/gi
            const matches = content.match(shortLinkPattern) || []
            const positionId = this.currentUser?.positionId
            if (!matches.length || !positionId) {
                copyRichTextWithMessage(content, this, '内容已复制到剪贴板', '复制失败')
                return
            }
            const uniqueLinks = Array.from(new Set(matches))
            try {
                // 批量转链：后端支持用 materialIds 批量生成推广链接
                const materialIds = uniqueLinks.join(',')
                const res = await batchCreatePromotionLinks({
                    materialIds,
                    positionId,
                    fetchGoodsInfo: false
                })
                // 构建 原始短链接 -> 转链后链接 映射
                const linkMap = {}
                if (res && res.data && Array.isArray(res.data)) {
                    res.data.forEach(linkItem => {
                        const originalLink = linkItem.materialId || ''
                        let convertedLink = originalLink

                        if (linkItem.code === 200) {
                            let linkData = null
                            if (linkItem.link) {
                                linkData = linkItem.link.data || linkItem.link
                            } else if (linkItem.data) {
                                linkData = linkItem.data
                            }

                            if (linkData) {
                                convertedLink = linkData.shortURL || linkData.clickURL || originalLink
                            }
                        }

                        if (originalLink && convertedLink) {
                            linkMap[originalLink] = convertedLink
                        }
                    })
                }
                // 替换内容中的所有短链接
                let finalContent = content
                uniqueLinks.forEach(link => {
                    const newLink = linkMap[link]
                    if (newLink && newLink !== link) {
                        const escaped = link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                        const re = new RegExp(escaped, 'g')
                        finalContent = finalContent.replace(re, newLink)
                    }
                })
                copyRichTextWithMessage(finalContent, this, '内容已复制到剪贴板', '复制失败')
            } catch (error) {
                this.$message.warning('转链失败，请自行转链！')
                copyRichTextWithMessage(content, this, '内容已复制到剪贴板', '复制失败')
            }
        },

        // 格式化时间
        formatTime(timeStr) {
            if (!timeStr) return ''
            const date = new Date(timeStr)
            return date.toLocaleString('zh-CN')
        },

        // 判断是否为富文本内容
        isRichText(content) {
            // 简单的判断：如果内容包含HTML标签，则认为是富文本
            return /<[^>]*>/.test(content);
        },

        // 处理滚动事件
        handleScroll(event) {
            const scrollContainer = event.target || this.$refs.resultsSection
            if (!scrollContainer) return

            const scrollTop = scrollContainer.scrollTop

            // 控制回到顶部按钮显示（滚动超过300px时显示）
            this.showBackToTop = scrollTop > 300
        },

        // 回到顶部
        scrollToTop() {
            const scrollContainer = this.$refs.resultsSection
            if (scrollContainer) {
                scrollContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
        },

        // 处理失效上报
        handleInvalidReport(item) {
            this.$confirm('确认该条信息已经失效、并上报！', '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'confirm-dialog-button',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                reportPromotionContentInvalidBySpuid(
                    item.skuName || item.spuid, // 使用标题或ID作为标识
                    this.currentUser?.positionId,
                    '攻略页面上报失效'
                ).then(response => {
                    if (response && response.success) {
                        this.$message({
                            type: 'success',
                            message: '上报成功!'
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: '上报失败'
                        })
                    }
                }).catch(error => {
                    console.error('上报失效失败:', error)
                    this.$message({
                        type: 'error',
                        message: '上报失败'
                    })
                })
            }).catch(() => {
                // 用户取消操作，不需要处理
            })
        }
    }
}
</script>

<style scoped>
.dacu-goods {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    box-sizing: border-box;
}

.query-section,
.results-section {
    /* margin-bottom: 10px; */
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #f9f9f9;
}

.results-section {
    height: calc(100vh - 195px);
    overflow-y: auto;
    padding: 20px;
    /* 隐藏滚动条但保持滚动功能 */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.results-section::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

.form-group {
    margin-bottom: 10px;
    width: 100%;
}

.form-group label {
    display: inline-block;
    width: 100px;
    font-weight: bold;
}

.form-group input,
.form-group select {
    width: 200px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: border-color 0.2s ease;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #42b983;
    box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
}

button {
    background: #42b983;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

button:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.stats {
    background: #e8f5e8;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.stats p {
    margin: 5px 0;
    font-weight: bold;
}

.goods-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 30px;
}

.goods-card {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    min-height: 120px;
    transition: box-shadow 0.2s;
}

.goods-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* 左侧商品图片区域 */
.goods-left {
    flex: 0 0 120px;
    position: relative;
    background: #f8f9fa;
}

.goods-image-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.goods-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-tags {
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.image-tag {
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    color: white;
}

.tag-type-4 {
    background: #ff6b35;
}

/* 超万人种草 */
.tag-type-5 {
    background: #28a745;
}

/* 京喜 */
.tag-type-8 {
    background: #fd7e14;
}

/* 超级补贴 */
.tag-type-12 {
    background: #17a2b8;
}

/* 7天无理由退货 */
.tag-type-14 {
    background: #6f42c1;
}

/* 同款高转化 */

.coupon-overlay {
    position: absolute;
    top: 0px;
    right: 0px;
}

.coupon-badge {
    background: #dc3545;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
}

.price-tags {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    width: 100px;
}

.main-price-tag {
    display: flex;
    align-items: center;
    gap: 8px;
}

.price-label {
    color: red;
    font-size: 18px;
    font-weight: bold;
}

.original-price {
    color: #ccc;
    font-size: 14px;
    text-decoration: line-through;
}

/* 右侧商品信息区域 */
.goods-right {
    flex: 1;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.price-commission-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.goods-title {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}


.price-row,
.commission-row,
.subsidy-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}

.price-label,
.commission-label,
.subsidy-label {
    font-size: 14px;
    color: #6c757d;
}

.price-value,
.commission-value,
.subsidy-value {
    font-size: 16px;
    font-weight: 600;
    color: #ff6b35;
}

.review-info {
    font-size: 12px;
    color: #6c757d;
}

.review-count,
.good-review-rate {
    margin-right: 12px;
}


.coupon-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 12px;
}

.coupon-amount {
    color: #856404;
    font-weight: 500;
}

.coupon-condition {
    color: #856404;
}

.goods-actions {
    display: flex;
    gap: 8px;
    margin-top: auto;
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    justify-content: center;
    flex: 1;
    /* margin-right: 8px; */
}

.download-btn {
    background: #42b983;
    color: white;
}

.download-btn:hover {
    background: #369870;
}

.share-btn {
    background: #42b983;
    color: white;
}

.share-btn:hover {
    background: #369870;
}

.icon-download,
.icon-share {
    width: 12px;
    height: 12px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .dacu-goods {
        padding: 10px;
    }

    .query-section,
    .results-section {
        padding: 10px 10px 0px 10px;
    }

    .form-group {
        display: flex;
        align-items: center;
    }

    .form-group label {
        width: auto;
        display: block;
        white-space: nowrap;
    }

    .form-group input,
    .form-group select {
        width: 100%;
        box-sizing: border-box;
    }

    .form-row {
        flex-direction: column;
    }

    .goods-card {
        flex-direction: column;
        min-height: auto;
    }

    .goods-left {
        width: 120px;
        height: 120px;
    }


    .goods-actions {
        flex-direction: row;
        gap: 8px;
    }
}

.goods-image {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.goods-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.goods-card:hover .goods-image img {
    transform: scale(1.05);
}

.image-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
}

.coupon-tag {
    background: #ff4757;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
}

.goods-info {
    padding: 16px;
}

.goods-title {
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 1.4;
    height: 2.8em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.price-info {
    margin-bottom: 12px;
}

.price-main {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.current-price {
    font-size: 18px;
    font-weight: 600;
    color: #e74c3c;
}

.original-price {
    font-size: 14px;
    color: #ccc;
    text-decoration: line-through;
}

.commission-info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #7f8c8d;
}

.commission-rate {
    color: #27ae60;
    font-weight: 500;
}

.commission-amount {
    color: #e67e22;
    font-weight: 500;
}

.shop-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 12px;
}

.shop-name {
    color: #34495e;
    font-weight: 500;
}

.shop-level {
    color: #f39c12;
    display: flex;
    align-items: center;
    gap: 2px;
}

.star {
    font-size: 10px;
}


.coupon-item {
    display: inline-block;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 11px;
}

.coupon-amount {
    color: #e17055;
    font-weight: 600;
}

.coupon-condition {
    color: #6c757d;
    margin-left: 4px;
}

.goods-tags {
    margin-bottom: 12px;
}

.tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 10px;
    margin-right: 4px;
    margin-bottom: 4px;
}

.tag-return {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.goods-actions {
    display: flex;
    gap: 8px;
}

.copy-btn {
    background: #6c757d;
    color: white;
}

.copy-btn:hover {
    background: #5a6268;
}

.view-btn {
    background: #007bff;
    color: white;
}

.view-btn:hover {
    background: #0056b3;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 30px;
}

.page-btn {
    padding: 8px 16px;
    border: 1px solid #dee2e6;
    background: white;
    color: #495057;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
}

.page-btn:hover:not(:disabled) {
    background: #e9ecef;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    color: #6c757d;
    font-size: 14px;
}

.loading {
    text-align: center;
    padding: 40px;
    color: #6c757d;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.error {
    text-align: center;
    padding: 40px;
    color: #dc3545;
}

.retry-btn {
    background: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 16px;
}

.retry-btn:hover {
    background: #c82333;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .dacu-goods {
        padding: 10px;
    }

    .filter-controls {
        flex-direction: column;
        align-items: stretch;
    }

    .filter-group {
        width: 100%;
    }

    .filter-group select {
        width: 100%;
    }

    .goods-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .goods-actions {
        flex-direction: row;
    }
}

/* 加载更多样式 */
.loading-more {
    text-align: center;
    padding: 20px;
    color: #6c757d;
}

.loading-more .loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #42b983;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 10px;
}

.no-more-data {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;
}

.no-more-data p {
    margin: 0;
}


/* 推广内容卡片样式 */
.content-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* 搜索结果统计样式 */
.search-stats {
    background: linear-gradient(135deg, #f8fffe 0%, #f0f9f6 100%);
    border: 1px solid #e1f5fe;
    border-radius: 8px;
}

.stats-info {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    font-size: 14px;
}

.search-keyword {
    background: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 500;
}

.search-category {
    background: #e8f5e8;
    color: #2e7d32;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 500;
}

.result-count {
    color: #42b983;
    font-weight: 600;
}

.content-card {
    background: white;
    border: 1px solid #e1e8ed;
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
}

.content-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
}

.content-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
    gap: 12px;
}

.content-title {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    line-height: 1.4;
    flex: 1;
}

.content-category {
    flex-shrink: 0;
}

.category-tag {
    background: #e3f2fd;
    color: #1976d2;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
}

.content-body {
    margin-bottom: 10px;
}

.content-text {
    color: #495057;
    line-height: 1.6;
    font-size: 14px;
    white-space: pre-wrap;
    word-break: break-word;
}

.content-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.content-status {
    flex-shrink: 0;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
}

.status-badge.active {
    background: #d4edda;
    color: #155724;
}

.status-badge.inactive {
    background: #f8d7da;
    color: #721c24;
}

.content-time {
    color: #6c757d;
    font-size: 12px;
    flex: 1;
}

.content-actions {
    display: flex;
    gap: 8px;
    width: 100%;
}

.copy-btn {
    background: #42b983;
    color: white;
}

.copy-btn:hover {
    background: #369870;
    transform: translateY(-1px);
}

/* 空状态样式 */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;
}

.empty-icon {
    font-size: 4rem;
    margin-bottom: 20px;
}

.empty-state h3 {
    margin: 0 0 10px 0;
    color: #495057;
    font-size: 18px;
}

.empty-state p {
    margin: 0;
    font-size: 14px;
}

/* 加载状态样式 */
.loading {
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #42b983;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .results-section {
        padding: 10px;
    }

    .content-card {
        padding: 10px;
    }

    .content-footer {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .content-actions {
        width: 100%;
    }
}

.back-to-top {
    position: fixed;
    bottom: 60px;
    right: 14px;
    width: 35px;
    height: 35px;
    background: #42b983;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    z-index: 1000;
}

.back-to-top:hover {
    background: #369870;
    transform: translateY(-2px);
}

.back-to-top i {
    font-size: 20px;
}
</style>